/*
 * Aligned Surgeons GraphQL query
 * @module src/graphql/getAlignedSurgeons
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_ALIGNED_SURGEONS = gql`
  query getAlignedSurgeons($filters: AlignedSurgeonFilters) {
    getAlignedSurgeons(filters: $filters) {
      id
      surgeonId
      surgeonName
      hospitalId
      accountName
    }
  }
`;
